import React from "react";

function Emagazine() {
  return (
    <div>
      <div className="row banner" style={{backgroundImage:'url(./images/bg.jpg)',backgroundSize:'cover',backgroundPosition:'center'}}>
      </div>
      <div className="" style={{backgroundImage:'url(./images/event.jpeg)',padding:'10px',backgroundSize:'cover',backgroundAttachment:'fixed'}}>
        <div className="row" style={{display:'flex',alignItems:'center',justifyContent:'center',width:'100%'}}>
            <div className="col-md-5" style={{backgroundImage:'url(./images/magazine.png)',height:'100vh',backgroundSize:'cover',backgroundPosition:'center',padding:'50px'}}>
                
            </div>
            <div className="col-md-7" style={{background:'#ffeccaf6',padding:'50px',height:'100vh'}}>
                <div className="row" style={{marginBottom:'50px',borderBottom:'1px solid orange',paddingBottom:'15px',paddingTop:'15px',background:'orange'}}>
                    <div className="col-md-12 ">
                       <center><p className="enquiry">E-Magazine - Read Online</p> </center>                                         
                    </div>
                </div>
                <div  style={{marginBottom:'50px',paddingBottom:'15px',paddingTop:'15px',display:'flex',flexWrap:'wrap',gap:'25px'}}>
                    <div class="col-md-3">
                        <button className="btn btn-warning" onClick={() => window.open("https://online.fliphtml5.com/enlpv/cudb/#p=1", "_blank")}> October 2025</button>
                    </div>
                     <div class="col-md-3">
                        <button className="btn btn-warning" onClick={() => window.open("https://online.fliphtml5.com/enlpv/hikj/#p=1", "_blank")}> September 2025</button>
                    </div>
                     <div class="col-md-3">
                        <button className="btn btn-warning" onClick={() => window.open("https://online.fliphtml5.com/enlpv/odwb/#p=1", "_blank")}> July 2025</button>
                    </div>
                      <div class="col-md-3">
                        <button className="btn btn-warning" onClick={() => window.open("https://online.fliphtml5.com/enlpv/zqdt/#p=1", "_blank")}> June 2025</button>
                    </div>
                      <div class="col-md-3">
                        <button className="btn btn-warning" onClick={() => window.open("https://online.fliphtml5.com/enlpv/hdrg/#p=1", "_blank")}> May 2025</button>
                    </div>
                        
                </div>
                
                
           </div> 
                      
        </div>
        
        
      </div>
    </div>
  );
}

export default Emagazine;